import Parser from 'html-react-parser'
import { useRef } from 'react'

import { Domain } from '../../../../igao/shared'
import './issue.scss'

const domainList = [{
  name: 'Review of Systems (Ox)',
  id: 'Ox'
},
{
  name: 'Pain and Symptoms (Sx)',
  id: 'Sx'
},
{
  name: 'Patient / Family / Community (Fx)',
  id: 'Fx'
},
{
  name: 'Treatment Plan (Tx)',
  id: 'Tx'
},
{
  name: 'Benefit Design and Coverage (Bx)',
  id: 'Bx'
},
{
  name: 'Provider Access Evaluation (Ax)',
  id: 'Ax'
},
{
  name: 'Goals and EOL Planning (Gx)',
  id: 'Gx'
},
{
  name: 'Knowledge and Choice (Kx)',
  id: 'Kx'
},
{
  name: 'Medications / Allergies (Rx)',
  id: 'Rx'
},
{
  name: 'Hospitalizations / ED visits (Ex)',
  id: 'Ex'
},
{
  name: 'Physical Exam (Px)',
  id: 'Px'
},
{
  name: 'Past Medical History (Hx)',
  id: 'Hx'
},
{
  name: 'Demographics (Nx)',
  id: 'Nx'
},
{
  name: 'Vitals (Vx)',
  id: 'Vx'
}]

const Issue = ({
  issue
}) => {
  const editMode = false
  const { domain } = issue
  const descriptionRef = useRef(null)
  const bodyClassName = `issue ${
    editMode && !issue.batchCheck ? 'issue-edit-mode' : ''
  } ${issue.draft ? 'draft' : ''}`
  const stateRef = useRef()

  stateRef.current = {
    issue
  }

  const prepareIssueDescription = description => {
    if (issue?.diff?.description) {
      const { current, previous } = issue.diff.description
      const currentRelations = [ ...current.matchAll('<span[^>]*>[^>]*<\\/span>') ]
      const previousRelations = [ ...previous.matchAll('<span[^>]*>[^>]*<\\/span>') ]
      const spans = Array.isArray(description) ? description?.filter(el => el?.type === 'span') : []
      currentRelations.map((v, k) => {
        if (v?.[0] !== previousRelations[k]?.[0]) {
          spans[k].props.style.color = '#e38d00'
          spans[k].props.style.background = '#f8e8c0'
          spans[k].props.style['border-radius'] = '16px'
          spans[k].props.style.padding = '3px 11px'
          spans[k].props.style.fontWeight = '500'
        }
        return v
      })
    }
    return description
  }

  const description = prepareIssueDescription(Parser(issue?.description || ''))

  const classNames = {
    issueBody: 'issue-item',
    issueContainer: 'issue-container'
  }

  return (
    <div
      className={classNames.issueBody}
      id={issue.id}
    >

      <div className={bodyClassName}>
        <div className={classNames.issueContainer}>
          <div className='left-group check content' />
          <Domain
            domain={domain}
            lists={{ domain: domainList }}
          />
          <div>
            <div
              ref={descriptionRef}
              className='description'
            >
              {description}
            </div>
          </div>
          {!editMode && (
            <span className='goal'>
              GOAL:
              {' '}
              {issue.goal}
            </span>
          )}
          <div className='id'>
            <div className='content'>
              Issue ID:
              {' '}
              {issue.id}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Issue
